/**
 * Recusively removes null items from Contentful GraphQL response arrays
 * Their API doesn't allow for filtering out draft items either
 * This isn't a fullproof solution since any linked entry can be a draft
 *
 * @param {*} obj
 * @return {*} obj
 * @example
 * items: [null, { foo: 'bar' }] => items: [ { foo: 'bar' } ]
 */
const removeDraftsFromContentful = obj => {
  for (let key in obj) {
    if (obj[key] === null) {
      continue;
    }
    if (Array.isArray(obj[key])) {
      obj[key] = obj[key].filter(item => item !== null);
      obj[key].forEach((item, i) => {
        if (typeof item === 'object' && item !== null) {
          obj[key][i] = removeDraftsFromContentful(item);
        }
      });
    } else if (typeof obj[key] === 'object') {
      obj[key] = removeDraftsFromContentful(obj[key]);
    }
  }
  return obj;
};

export { removeDraftsFromContentful };
